import AbstractBaseError from './AbstractBaseError';

export default class LogicException extends AbstractBaseError {
	name = 'LogicException';
}
